import React from 'react';

import {
  MinimizedItemBadgeContainer,
  MinimizedItemContentContainer,
  MinimizedItemCotainer,
  OpenItems,
} from '../style';
import { providerItemType } from 'store/providers/providerTypes';
import ActionLink from '../../../ActionLink/ActionLink';
import Icon from '../../../Icon/Icon';
import { red } from '../../../../utils/style/colors';
import APopover from '../../../APopover/APopover';
import QuillManagerModal from '../Quill/QuillManagerModal';
import SurveyManagerModal from './SurveyManagerModal';
import SearchTagManagerModal from '../SearchTag/SearchTagManagerModal';
import SurveyReportModal from '../SurveyReport/SurveyReportModal';
import { IOpenItem } from '../../../../store/entity/IOpenItem';
import DocumentViewModal from '../DocumentViewerModal/DocumentViewModal';
import UserMixpanel from '../../../../utils/mixpanel/MixpanelClass';
import { summerizeText } from '../../../../utils/summerizeText';
import LocalIcon from '../../../../ui/LocalIcon';
import {
  IconColorFinder,
  IconLogoFinder,
} from '../../../../utils/check-file-type/findIconViaType';

interface IComponentProps {
  openItems: IOpenItem[];
  openId: string | number;
  onReOpen: (id: number) => void;
  onClose: (id: number) => void;
  onMinimize: (id: number) => void;
  changeState: (id: number, state: string) => void;
  dispatch: (action: any) => any;
  openNextItem: (providerId: number) => void;
  onDeleteQueryparams?: (id: number) => void;
  onAddQueryparams?: (id: number) => void;
  onReplaceQueryparams?: (id: number) => void;
}

interface IComponentState {}

class ItemsViewer extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  handleCloseFunction = (id: number) => () => {
    // this.handleDeleteQueryParam(id);
    // mentioned while we close act as backward ...
    this.props.onClose(id);
  };

  handleMinimizeFunction = (id: number) => () => {
    this.props.onMinimize(id);
  };

  handleChangeState = (itemId: number, state: string) => {
    this.props.changeState(itemId, state);
  };

  getItemSnippet(openItem: IOpenItem, _: number, openId: number) {
    return (
      <APopover
        arrow
        curveBorder
        target={
          <MinimizedItemCotainer>
            <ActionLink
              key={openItem.item.data?.id}
              onClick={() => {
                this.props.onReOpen(openItem.item.data.id);
              }}
              style={{ flex: '1' }}
            >
              <MinimizedItemBadgeContainer
                color={IconColorFinder(openItem.item.data?.type)}
              >
                <LocalIcon
                  type={'sm'}
                  iconName={IconLogoFinder({ type: openItem.item.data?.type })}
                />
              </MinimizedItemBadgeContainer>
              <MinimizedItemContentContainer
                isOpen={openItem.item.data?.id === openId}
              >
                {summerizeText(openItem.item.data.name, 13)}
              </MinimizedItemContentContainer>
            </ActionLink>
            <div key={openItem.item.data.id + '.close'}>
              <ActionLink
                onClick={this.handleCloseFunction(openItem.item.data.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '30px',
                  padding: '5px',
                }}
              >
                <Icon type={'x'} color={red} />
              </ActionLink>
            </div>
          </MinimizedItemCotainer>
        }
        trigger={'hover'}
      >
        <div>{openItem.item.data.name}</div>
      </APopover>
    );
  }

  render() {
    const { openItems, openId, dispatch } = this.props;
    if (openItems.length !== 0) {
      return (
        <div>
          <nav
            style={{
              position: 'fixed',
              right: 0,
              bottom: 0,
              zIndex: 20000,
              padding: '0.75rem',
              backgroundColor: 'var(--exact-white)',
            }}
          >
            <div className="nav-wrapper">
              <OpenItems className="right">
                {openItems.map((openItem: IOpenItem, index: number) => {
                  return this.getItemSnippet(
                    openItem,
                    index,
                    Number(this.props.openId)
                  );
                })}
              </OpenItems>
            </div>
          </nav>
          {openItems.map((openItem: IOpenItem) => {
            return this.getItemView(openItem, dispatch, Number(openId));
          })}
        </div>
      );
    } else {
      return null;
    }
  }

  getItemView(
    openItem: IOpenItem,
    dispatch: (action: any) => any,
    openId: number
  ) {
    const {
      item: { data },
    } = openItem;
    const mx = UserMixpanel.getInstance();
    if (data.type === providerItemType.document) {
      if (openItem.status === 'view')
        mx.sendVisitDocumentTrack(`${data.id} - ${data.name} - document`);
      if (data.document?.properties.format === 'quill') {
        return (
          <QuillManagerModal
            key={data.id}
            openItem={openItem}
            changeState={(state: string) =>
              this.handleChangeState(data.id, state)
            }
            dispatch={dispatch}
            isOpen={openId === data.id}
            onClose={this.handleCloseFunction(data.id)}
            onMinimize={this.handleMinimizeFunction(data.id)}
          />
        );
      }
      return (
        <DocumentViewModal
          key={data.id}
          openItem={openItem}
          changeState={(state: string) =>
            this.handleChangeState(data.id, state)
          }
          dispatch={dispatch}
          isOpen={openId === data.id}
          onClose={this.handleCloseFunction(data.id)}
          onMinimize={this.handleMinimizeFunction(data.id)}
        />
      );
    } else if (data.type === providerItemType.survey) {
      return (
        <SurveyManagerModal
          key={data.id}
          openItem={openItem}
          changeState={(state: string) =>
            this.handleChangeState(data.id, state)
          }
          dispatch={dispatch}
          isOpen={openId === data.id}
          onClose={this.handleCloseFunction(data.id)}
          onMinimize={this.handleMinimizeFunction(data.id)}
          openNextItem={() =>
            this.props.openNextItem(openItem.item.data.providerId)
          }
        />
      );
    } else if (data.type === providerItemType.searchTag) {
      return (
        <SearchTagManagerModal
          key={data.id}
          openItem={openItem}
          changeState={(state: string) =>
            this.handleChangeState(data.id, state)
          }
          dispatch={dispatch}
          isOpen={openId === data.id}
          onClose={this.handleCloseFunction(data.id)}
          onMinimize={this.handleMinimizeFunction(data.id)}
        />
      );
    } else if (data.type === providerItemType.surveyReport) {
      return (
        <SurveyReportModal
          key={data.id}
          openItem={openItem}
          dispatch={dispatch}
          isOpen={openId === data.id}
          onClose={this.handleCloseFunction(data.id)}
          onMinimize={this.handleMinimizeFunction(data.id)}
        />
      );
    }
    return null;
  }
}

export default ItemsViewer;
